import * as yup from 'yup';

export const createAccountSchema = yup.object().shape({
  email: yup.string().email('email').required('required'),
});

export const defaultValuesCreateAccountForm = {
  email: '',
};
